import type { CacheStorageOptions } from '@/shared/lib/hooks/use-cache-storage';
import { AttributesApi } from '@/entities/srm/ci';
import { useArrayMap } from '@/shared/lib/hooks/array-map';
import { useCacheStorage } from '@/shared/lib/hooks/use-cache-storage';
import { Page } from '@/shared/api/pagination';
import { Attribute } from '@/entities/srm/ci';
import { useMemo } from 'react';

export const attributesQueryConfig: CacheStorageOptions<Page<Attribute>> = {
  meta: { cacheStorageEvent: 'attributes' },
  queryKey: ['attributes'],
  queryFn: ({ signal }) =>
    AttributesApi.getAttributes({
      params: { size: -1 },
      signal,
      timeout: 15000,
    }).then((res) => res.data),
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  cacheTime: Infinity,
};
export const useAttributesStorage = () => {
  return useCacheStorage<Page<Attribute>>({
    queryConfig: attributesQueryConfig,
  });
};
export const useAttributesMap = (key = 'name') => {
  const { data, ...rest } = useAttributesStorage();
  const items = data?.items || [];
  const memoizedData = useArrayMap(items, key);
  return useMemo(() => ({ ...rest, data: memoizedData }), [memoizedData, rest]);
};